import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { isAppLang } from 'utils';
import { usePlatform } from 'hooks';

export default function NavigateToLanding() {
  const navigate = useNavigate();
  const defaultLandingPageSelectBox = useSelector(
    (state) => state.settingsReducer.filters.public.defaultLandingPageSelectBox
  );
  const hasFreeSearchPermission = useSelector(
    (state) =>
      state.accountReducer.currentUser?.user?.permissions?.FrontEnd?.freeSearch
        ?.permission
  );
  const { getSettingsDefaultPlatform } = usePlatform();

  useEffect(() => {
    const selectedPlatform =
      defaultLandingPageSelectBox.selectedValue === 'statistics'
        ? getSettingsDefaultPlatform('statistics')
        : getSettingsDefaultPlatform();

    let landingPath = `/${defaultLandingPageSelectBox.selectedValue}/${selectedPlatform}`;
    if (
      !hasFreeSearchPermission &&
      !isAppLang('ar') &&
      defaultLandingPageSelectBox.selectedValue === 'search'
    )
      landingPath = `/contents/${selectedPlatform}`;
    else if (
      (hasFreeSearchPermission &&
        defaultLandingPageSelectBox.selectedValue === 'search') ||
      defaultLandingPageSelectBox.selectedValue?.includes('comparison')
    )
      landingPath = `/${defaultLandingPageSelectBox.selectedValue}`;

    navigate(landingPath, {
      replace: true,
    });
  }, []);

  return <></>;
}
